<div class="navbar-wrapper"
  [ngClass]="{'container': this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'}">
  <app-user-nav-content (onNavMobCollapse)="navMobCollapse()"></app-user-nav-content>
</div>